module.exports = __webpack_public_path__ + "media/images/home-panel-background-9fb469a20a95040ebfc5991c0d202ad6.png";